import styles from "./LoadingIndicator.module.css";
import { LoadingIcon } from "../../assets";
import { PropsWithChildren, useContext } from "react";
import { AppContext } from "../../state";
import { useI18n } from "../../i18n";

type LoadingIndicatorProps = PropsWithChildren;

export const WithLoadingIndicator = (props: LoadingIndicatorProps) => {
  const { children } = props;

  const { t } = useI18n();
  const state = useContext(AppContext);

  return state.calculation.hasCalculated ? (
    children
  ) : (
    <div className={styles.loadingIndicator} data-test-id="loadingIndicator">
      <span className={styles.visuallyHidden}>{t("hints.loading")}</span>
      <LoadingIcon height={70} width={70} className={styles.loadingIcon} aria-hidden />
    </div>
  );
};
